import { hbs } from 'ember-cli-htmlbars';
export default hbs('<Shared::LoadingSpinner />', { moduleName: 'later/templates/loading.hbs' });
